<template>
  <div style="background-color: white; padding: 20px;">
    <div style="margin-bottom: 20px;display: flex">
      <select-area @areaListId="getAreaListId" :clear="true"/>
      <el-date-picker style="width: 160px;"
          v-model="query.date"
          type="month"
          format="YYYY/MM"
          value-format="YYYY-MM"
          placeholder="请选择"
          @click.stop
          @calendar-change.stop
      />
      <el-select v-model="query.type" placeholder="请选择"  style="width: 160px;margin-left: 10px">
        <el-option label="全部" :value="0"/>
        <el-option label="有价值未出勤学员" :value="1"/>
        <el-option label="有价值已出勤学员" :value="2"/>
      </el-select>
      <el-button style="margin-left: 10px" type="primary" @click="loadAreaWeekAttendance">查询</el-button>
      <el-button style="margin-left: 10px" type="primary" @click="exportWeekAttendance">导出</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="deptName" label="校区名称" min-width="200"/>
      <el-table-column align="center" v-for="(item, index) in weekList" :key="index" width="300">
        <template #header>
          <div style="margin: 10px 0">第{{ item.week }}周<text style="font-weight: normal">（{{item.startDate}} ~ {{item.endDate}}）</text></div>
        </template>
        <el-table-column prop="monthCount" label="在籍人数" width="100">
          <template #default="scope">
            <div v-if="scope.row.list.length>0">{{ scope.row.list[index].weekCount }}</div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="monthCount" label="出勤人数" width="100">
          <template #default="scope">
            <div v-if="scope.row.list.length>0">{{ scope.row.list[index].weekAttendanceCount }}</div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="monthCount" label="出勤率" width="100">
          <template #default="scope">
            <div v-if="scope.row.list.length>0">{{ scope.row.list[index].attendanceRate }}%</div>
            <div v-else></div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column fixed="right" label="月总在籍" width="300">
        <el-table-column prop="monthCount" label="在籍人数" width="100"/>
        <el-table-column prop="monthAttCount" label="出勤人数" width="100"/>
        <el-table-column label="出勤率" width="100">
          <template #default="scope">{{ scope.row.attendanceRate }}%</template>
        </el-table-column>

      </el-table-column>
      <el-table-column width="100"  fixed="right" label="操作">
        <template #default="scope">
          <el-button link type="primary" size="small" @click="setStudentQuery(scope.row)">学员列表</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          style="text-align: right;margin: 20px 10px;"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="query.pageSize"
          @current-change="selectPage"
          layout="total, prev, pager, next, jumper"
          :total="tableTotal">
      </el-pagination>
    </div>
    <el-dialog v-model="studentDialog" title="学员列表" width="1200">
      <div style="margin-bottom: 20px">
        <el-date-picker style="width: 160px;"
                        v-model="studentQuery.date"
                        type="month"
                        format="YYYY/MM"
                        value-format="YYYY-MM"
                        placeholder="请选择"
                        @click.stop
                        @calendar-change.stop
        />
        <el-select v-model="studentQuery.type" placeholder="请选择"  style="width: 160px;margin-left: 10px">
          <el-option label="全部" :value="0"/>
          <el-option label="未出勤" :value="1"/>
          <el-option label="已出勤" :value="2"/>
        </el-select>
        <el-select v-model="studentQuery.week" placeholder="请选择"  style="width: 160px;margin-left: 10px">
          <el-option v-for="item in weekList" :key="item.week" :label="item.week+'周'" :value="item.week"/>
        </el-select>
        <el-button style="margin-left: 10px" type="primary" @click="getWeekApportionPage">查询</el-button>
      </div>
      <el-table :data="studentList" style="width: 100%" height="440px">
        <el-table-column prop="studentName" label="学员姓名" />
        <el-table-column prop="orderId" label="订单Id" />
        <el-table-column prop="state" label="状态" />
        <el-table-column prop="endingBalance" label="期末余额" />
        <el-table-column prop="city" label="城市" />
        <el-table-column prop="coursesAreaName" label="实际上课校区" />
        <el-table-column prop="city" label="周">
          <template #default="scope">
            <el-button link type="primary" size="small">{{scope.row.weekNum}}周</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="campusName" label="上课校区" />
      </el-table>
      <div class="pagination">
        <el-pagination
            style="text-align: right;margin: 20px 10px;"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="query.pageSize"
            @current-change="selectStudentPage"
            layout="total, prev, pager, next, jumper"
            :total="studentTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {loadAreaWeekAttendance, selectMonthTimeSlot,getWeekApportionPage,exportWeekAttendance} from "@/api/coursesRecord";
import SelectArea from "../../components/SelectArea";
export default {
  name: "Attendance",
  components:{
    SelectArea
  },
  data() {
    return {
      studentList:[],
      studentTotal:0,
      studentDialog:false,

      tableData: [],
      tableTotal: 0,
      weekList: [],
      query: {
        date:null,
        year:null,
        month:null,
        type:0,
        areaIdList:[],
        pageIndex: 1,
        pageSize: 12,
      },
      studentQuery:{
        date:null,
        year:null,
        month:null,
        type:0,week:null,

        areaIdList:[],
        pageIndex: 1,
        pageSize: 10,
      }
    }
  },
  methods: {
    setStudentQuery(val){
      this.studentQuery.areaIdList = [val.deptId];
      this.studentDialog = true;
      this.studentQuery.year = this.query.year;
      this.studentQuery.month = this.query.month;
      this.studentQuery.date = this.query.date;
      this.studentQuery.type = this.query.type;
      this.getWeekApportionPage();
    },
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
    selectPage(index) {
      this.query.pageIndex = index;
      this.loadAreaWeekAttendance();
    },
    selectStudentPage(index){
      this.studentQuery.pageIndex = index;
      this.getWeekApportionPage();
    },
    selectMonthTimeSlot() {
      this.weekList = [];
      selectMonthTimeSlot(this.query).then(val => {
        if (val.code == 200) {
          this.weekList = val.data;
        } else {
          this.$message.error("获取周列表失败！");
        }
      })
    },
    loadAreaWeekAttendance() {

      if (this.query.date){
        const date = this.query.date.split('-');
        this.query.year = date[0];
        this.query.month = date[1];
      }else {
        this.query.year = null;
        this.query.month = null;
      }
      this.selectMonthTimeSlot();
      loadAreaWeekAttendance(this.query).then(val => {
        if (val.code == 200) {
          this.tableData = val.data.records;
          this.tableTotal = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    },
    getWeekApportionPage(){
      if (this.studentQuery.date){
        const date = this.studentQuery.date.split('-');
        this.studentQuery.year = date[0];
        this.studentQuery.month = date[1];
      }else {
        this.studentQuery.year = null;
        this.studentQuery.month = null;
      }
      getWeekApportionPage(this.studentQuery).then(val=>{
        this.studentDialog = true;
        if (val.code == 200) {
          this.studentList = val.data.records;
          this.studentTotal = val.data.total;
        } else {
          this.$message.error("获取学生表格数据失败");
        }
      })
    },
    exportWeekAttendance(){
      exportWeekAttendance(this.query).then(val => {
        if (val.code == 200) {
          this.$message.success('导出成功，右上角查看！');
        } else {
          this.message("推送失败", val.message, "error")
        }
      });

    }
  },
  created() {
    console.log("AAAAAAAAAAAAAAAAAAAAAAA")
    this.loadAreaWeekAttendance();
  }
}
</script>

